import React, { ReactElement } from 'react';
import { Space, Typography } from 'antd';

import HealthDocumentStatusBadge from './HealthDocumentStatusBadge';
import type { HealthDocument } from 'leash/types';
import { HealthDocumentTypeId } from 'leash/types';

interface Props {
  documents: HealthDocument[];
}

function HealthDocumentStatus({ documents }: Props): ReactElement {
  return (
    <Space size="small" align="center" data-testid="package-filters">
      <Typography.Text strong>Document Status</Typography.Text>
      <HealthDocumentStatusBadge
        documentType={HealthDocumentTypeId.HealthCertificate}
        documents={documents}
      />
      <HealthDocumentStatusBadge
        documentType={HealthDocumentTypeId.VeterinaryHealthReport}
        documents={documents}
      />
      <HealthDocumentStatusBadge
        documentType={HealthDocumentTypeId.VaccineRecord}
        documents={documents}
      />
    </Space>
  );
}

export default HealthDocumentStatus;
